<template>
    <main>
        <ViewNavBar />
        <div v-if="emergencyModeSettings && emergencyModeSettings.emergencyMode && emergencyModeSettings.viewModeEmergencyBanner" class="alert-banner-container">
            <div class="banner-content-container">
                <div class="banner-text-container">
                    <div class="info-icon">
                        <Icon :icon-name="'info'" />
                    </div>
                    <div class="message">
                        {{ emergencyModeSettings.viewModeEmergencyBannerText }}
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="portfolioUsesRootHeaderSections"
            :class="['ufo--portfolio-page', templateSettings.theme, { home: project?.type === 'home' }]"
            :data-template-name="templateName"
        >
            <SectionLoader
                :sections="project.sections"
                :class="[isFirstSectionCaseStudyGrid ? 'pg-first' : '']"
                :default-image-alt="''"
            />
        </div>
        <template v-else>
            <!-- OLD LAYOUT -->
            <div :class="['ufo--portfolio-page',
                        'profile-page',
                        templateSettings.theme ? templateSettings.theme : 'profile_theme_default_old',
                        templateSettings.showProfilePicture ? 'profile--hp' : '']"
                 :data-template-name="templateName"
                 v-if="!templateSettings.theme || templateSettings.theme.includes('profile_')"
            >
                <div class="grid ufo--page-hero" :style="[ sidebarBackgroundColor ]"
                    @mouseenter="hover = -1" @mouseleave="hover = null"
                >
                    <div :class="['ufo--page-hero-content', templateSettings.showProfilePicture && (portfolio.image.url || user.image.url && !portfolio.image.url) ? 'has-picture' : 'no-profile-picture', contentPosition]">
                        <PortfolioHeroHelper />
                    </div>
                </div>
                <div class="ufo--page-content ufo--home-page-content">
                    <GetHeroNavigation v-if=" !templateSettings.theme || templateSettings.theme && templateSettings.theme.includes('profile_theme_default')" :show-home-button="true" />
                    <SectionLoader :sections="project.sections" :default-image-alt="''"/>
                </div>
                <LegacyPublicPageFooter />
            </div>
            <!-- NEW LAYOUT -->
            <div v-else :class="['ufo--portfolio-page', templateSettings.theme]"
                 :data-template-name="templateName"
            >
                <PortfolioHeroHelper />
                <div class="ufo--page-content ufo--home-page-content">
                    <SectionLoader :sections="project.sections" :class="['ufo--page-sections', isFirstSectionCaseStudyGrid ? 'pg-first' : '']" :default-image-alt="''"/>
                </div>
                <LegacyPublicPageFooter />
            </div>
        </template>
    </main>
</template>

<script>
import {useHead} from '@unhead/vue'
import PortfolioHeroHelper from "../portfolio/themes/_helper/PortfolioHeroHelper.vue";
import SectionLoader from "../portfolio/sections/SectionLoader.vue";
import GetHeroNavigation from "../portfolio/common/hero/GetHeroNavigation.vue";
import LegacyPublicPageFooter from "./common/LegacyPublicPageFooter.vue";
import Icon from "../../common/Icon.vue";
import ViewNavBar from "./ViewNavBar.vue";
import {mapGetters} from "vuex";
import {injectCssVars} from "@/scripts/common/utilities/cssVars.js";
import {SectionTypesEnum} from "@/scripts/common/enums.js";
import {buildPortfolioSocialHead} from "./socialHead.js";
import {templatePreviewMixin} from "@/scripts/adminSite/aiPortfolioGenerator/templatePreviewMixin.js";

let myPageHead = null;

    export default {
        name: "PortfolioPage",
        mixins: [templatePreviewMixin],
        components: {
            ViewNavBar,
            GetHeroNavigation,
            SectionLoader,
            PortfolioHeroHelper,
            LegacyPublicPageFooter,
            Icon
        },
        data() {
            return {
                hover:null,
            }
        },
        beforeMount() {
            injectCssVars(this.getAllCssVars);
        },
        mounted() {
            myPageHead = useHead(() => this.headTags)
            if (window.scrollY) {window.scroll(0, 0)}
        },
        unmounted() {
            myPageHead?.dispose()
        },
        computed: {
            ...mapGetters("design", ["getAllCssVars", "fontStyles"],),
            ...mapGetters("view", ["viewData"]),
            ...mapGetters(["portfolioUsesRootHeaderSections"]),
            portfolio() {
                return this.viewData.portfolio;
            },
            socialHead() {
                return buildPortfolioSocialHead({
                    portfolio: this.portfolio,
                    project: this.project,
                    user: this.user,
                    route: this.$route,
                });
            },
            headTags() {
                return this.socialHead;
            },
            user() {
                return this.viewData.user;
            },
            project() {
                return this.viewData.project;
            },
            templateSettings() {
                return this.portfolio.templateSettings;
            },
            portfolioPages() {
                return this.viewData.portfolioPages;
            },
            emergencyModeSettings() {
                return this.viewData.emergencyModeSettings;
            },
            sidebarBackgroundColor() {
                return {
                    '--sidebarBgColor': this.portfolio.templateSettings.hero && this.portfolio.templateSettings.hero.sidebarSettings
                        ? this.portfolio.templateSettings.hero.sidebarSettings.backgroundColor
                        : null
                }
            },
            contentPosition() {
                return this.templateSettings.theme === "profile_theme_nine"
                    ? `align-content-to-${this.templateSettings.hero.alignment.vertical}`
                    : null
            },
            isFirstSectionCaseStudyGrid() {
                return this.project.sections[0]?.type === SectionTypesEnum.CASE_STUDY_GRID
            },
            templateName() {
                return this.portfolio
                    ? this.$store.getters?.getTemplateForPortfolio?.(this.portfolio)?.name || ""
                    : "";
            }
        }
    }
</script>

<style lang="scss" global>
.alert-banner-container {
    min-height: 56px;
    width: 100%;
    background-color: var(--volt);
    display: flex;
    justify-content: center;

    @media (max-width: 769px) {
        min-height: 56px;
    }

    @media (max-width: 640px) {
        min-height: 70px;
    }

    .banner-content-container {
        @media (max-width: 769px) {
            padding: 0 62px;
        }

        @media (max-width: 640px) {
            padding: 0;
        }

        .banner-text-container {
            padding: 16px;
            display: flex;

            @media (max-width: 640px) {
                padding: 12px 6px;
            }

            .info-icon {
                @media (max-width: 640px) {
                    font-size: 12px;
                }

                svg {
                    height: 20px;
                    color: var(--asphalt100)
                }
            }

            .message {
                margin-left: 8px;
                color: var(--asphalt100);
                font-family: var(--primarySans);
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 24px; /* 150% */
                letter-spacing: 0.16px;

                @media (max-width: 769px) {
                    font-size: 9px;
                }
            }
        }
    }
}
</style>
